import getProductPrice from '../helpers/getProductPrice';


const productModel = function googleAnalyticsProductModel(product, options = {}, isPurchaseEvent) {
  const {
    list,
    quantity = 1,
    affiliation = 'Marketplace',
    index = 0,
  } = options;

  const model = {
    item_id: product.id,
    item_brand: product.brand,
    item_name: product.productName,
    price: getProductPrice(product, isPurchaseEvent),
    quantity,
    item_list_name: list || product.primaryCategoryName,
    item_category: list || product.primaryCategoryName,
    affiliation,
    index,
  };

  return model;
};

export default productModel;
